import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SingleResponse } from '../interfaces/responses.interface';
import { TemaSitio } from '../layout/theme/site-theme';
import { environment } from 'src/environments/environment';

/**
 * Lee (público) y guarda (solo ADMIN) la paleta del sitio en el servidor.
 */
@Injectable({
  providedIn: 'root'
})
export class TemaService {
  private http = inject(HttpClient);

  get(): Observable<SingleResponse<TemaSitio>> {
    return this.http.get<SingleResponse<TemaSitio>>(`${environment.API_URL}/tema/view`);
  }

  update(data: TemaSitio): Observable<SingleResponse<TemaSitio>> {
    return this.http.put<SingleResponse<TemaSitio>>(`${environment.API_URL}/tema/update`, { data });
  }
}
